/** Define os meses (formato "MM") a tentar na importação de saldos FNDE,
 * em ordem de prioridade. Para o ano base igual ao atual, parte do mês corrente
 * e desce até janeiro (último mês com dados); caso contrário, usa dezembro. */
export function mesesParaImportar(anoBase, anoAtual, mesAtual) {
  if (Number(anoBase) !== Number(anoAtual)) {
    return ['12'];
  }
  const topo = Number(mesAtual);
  const lista = [];
  for (let m = topo; m >= 1; m--) {
    lista.push(String(m).padStart(2, '0'));
  }
  return lista;
}

export default mesesParaImportar;